import { saveItem } from "action/shopping-cart/saveItem";
import { VEHICLE_FITMENT } from "constant/shared-constants";
import { RootState } from "interfaces/generics.type";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./card-actions.module.scss";

function SaveButton({ product = {}, className = "" }: any) {
  const [isSavedItem, setSavedItem] = useState(false);
  const dispatch = useDispatch();

  const { savedItems } = useSelector((store: RootState) => store.shoppingCart);
  const { selectedVehicle } = useSelector((store: RootState) => store.garage);

  useEffect(() => {
    const isThisSavedItem = savedItems.some((item: any) => item.sku === product.sku);
    setSavedItem(isThisSavedItem);
  }, [savedItems]);

  const handleSaveItemForLater = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    const saveOrRemove = !isSavedItem;
    const callback = null;
    dispatch(saveItem(
      product,
      selectedVehicle,
      callback,
      saveOrRemove ? product.fitment === VEHICLE_FITMENT.UNIVERSAL : true,
      saveOrRemove ? 1 : 0,
    ));
  };

  const classname = isSavedItem ? `fa-heart ${styles.fa_heart}` : styles.fa_heart_o;

  return (
    <button type="button" className={`btn ${styles.action_button} ${styles.btn_save} ${className}`} onClick={handleSaveItemForLater}>
      <i className={`fa ${classname}`} />
    </button>
  );
}

export default SaveButton;
